import { create } from "zustand";

const baseUrl = "https://admin.talentlinkindo.com/api";

type JobFilterKey =
  | "jobTypes"
  | "degrees"
  | "experiences"
  | "industries"
  | "workingTypes"
  | "locations"
  | "skillSet"
  | "sizes"
  | "benefitSet"
  | "genders"
  | "joinNotice"
  | "languageSet"
  | "proficiencies"
  | "jobPreferences"
  | "experienceLevels"
  | "martialStatus"
  | "countries"
  | "states"
  | "cities";

type JobFilterStore = {
  jobTypes: any[];
  degrees: any[];
  experiences: any[];
  industries: any[];
  workingTypes: any[];
  skillSet: any[];
  sizes: any[];
  locations: any[];
  benefitSet: any[];
  jobPreferences: any[];
  genders: any[];
  joinNotice: any[];
  languageSet: any[];
  proficiencies: any[];
  experienceLevels: any[];
  martialStatus: any[];
  countries: any[];
  states: any[];
  cities: any[];
  fetchFilters: (lang: "en" | "id", type?: JobFilterKey | "all") => Promise<void>;
  fetchStates: (countryId: number, lang: "en" | "id") => Promise<void>;
  fetchCities: (stateId: number, lang: "en" | "id") => Promise<void>;
};

export const useJobFilterStore = create<JobFilterStore>((set) => ({
  jobTypes: [],
  degrees: [],
  experiences: [],
  industries: [],
  workingTypes: [],
  skillSet: [],
  sizes: [],
  locations: [],
  benefitSet: [],
  jobPreferences: [],
  genders: [],
  joinNotice: [],
  languageSet: [],
  proficiencies: [],
  experienceLevels: [],
  martialStatus: [],
  countries: [],
  states: [],
  cities: [],

  fetchFilters: async (lang, type = "all") => {
    try {
      const endpointsMap: Record<JobFilterKey, string> = {
        jobTypes: "job-type",
        degrees: "degree",
        experiences: "experience",
        industries: "industry",
        workingTypes: "working-type",
        locations: "all-cities",
        skillSet: "skill",
        sizes: "size",
        benefitSet: "benefit",
        joinNotice: "join-availabilities",
        jobPreferences: "job-preferences",
        genders: "gender",
        languageSet: "languages",
        proficiencies: "proficiencies",
        experienceLevels: "experience-levels",
        martialStatus: "martial-statuses",
        countries: "countries",
        states: "",
        cities: "", // fetch cities pakai method terpisah
      };

      const keys = type === "all" ? Object.keys(endpointsMap) as JobFilterKey[] : [type];

      const responses = await Promise.all(
        keys
          .filter((key) => endpointsMap[key]) // skip states & cities
          .map((key) => fetch(`${baseUrl}/${lang}/${endpointsMap[key]}`))
      );

      const data = await Promise.all(responses.map((res) => res.json()));

      const newState: Partial<Record<JobFilterKey, any[]>> = {};
      keys.forEach((key, index) => {
        if (endpointsMap[key]) newState[key] = data[index]?.data || [];
      });

      set(newState);
    } catch (error) {
      console.error("❌ Failed to fetch filters:", error);
    }
  },

  fetchStates: async (countryId, lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/countries/${countryId}/states`);
      const data = await res.json();
      set({ states: data?.data || [], cities: [] }); // reset cities ketika ganti negara
    } catch (error) {
      console.error("❌ Failed to fetch states:", error);
    }
  },

  fetchCities: async (stateId, lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/states/${stateId}/cities`);
      const data = await res.json();
      set({ cities: data?.data || [] });
    } catch (error) {
      console.error("❌ Failed to fetch cities:", error);
    }
  },
}));
